import { Route } from '@/types'

export const langeroute: Route = {
  id: 'langeroute',
  label: 'Lange Route',
  duration:
    'De fietstocht duurt ongeveer 4 uur. Het eerste uur daarvan geniet je op de waterbus van het mooie zicht op de haven.',
  center: {
    lat: 51.222334052000555,
    lon: 4.397256409857123
  },
  steps: [
    {
      label: 'Het Steen (game)',
      component: 'Steen2',
      coordinates: {
        lat: 51.22233405,
        lon: 4.39685641
      },
      instruction:
        'Zet je op een mooi plekje met zicht op Het Steen en het water',
      nextSteps:
        'Neem de waterbus vanop het ponton aan Het Steen tot in Lillo.',
      type: 'game'
    },
    {
      label: 'Fort Lillo (game)',
      component: 'FortLillo',
      coordinates: {
        lat: 51.30399954,
        lon: 4.2882896
      },
      poiCoordinates: {
        lat: 51.30456705,
        lon: 4.289938133
      },
      instruction: 'Wandel van de steiger het centrum van Fort Lillo binnen',
      nextSteps:
        'Volg het fietspad zo’n 5 kilometer (15 min) tot je aan een splitsing komt en zicht hebt op de sluizen.',
      type: 'game'
    },
    {
      label: 'Kijken welke sluis open staat',
      component: 'Splitsing',
      coordinates: {
        lat: 51.33950836,
        lon: 4.285341438
      },
      instruction:
        'Je komt aan bij een splitsing. Er staat altijd één van de twee sluizen open. Fiets in de richting van de sluis waar je over kan fietsen. Zet je fiets even op een veilig plekje tussen de sluizen of net voorbij de sluis',
      type: 'warning'
    },
    {
      label: 'Berendrechtsluis',
      component: 'BerendrechtSluis',
      coordinates: {
        lat: 51.34716718,
        lon: 4.282106717
      },
      poiCoordinates: {
        lat: 51.34714624,
        lon: 4.28223144
      },
      instruction:
        'Steek de straat over en zet je fiets op de hoek van Scheldelaan en Zandvlietweg. Draai nadien linksaf naar Zandvlietweg',
      nextSteps:
        'Fiets 650 meter verder en houdt halte onder de windturbine waar de 2 banen terug samenkomen.',
      type: 'game'
    },
    {
      label: 'Windturbine (game) + BASF (info)',
      component: 'Windturbine2',
      coordinates: {
        lat: 51.35240537,
        lon: 4.282639163
      },
      poiCoordinates: {
        lat: 51.35248577,
        lon: 4.282961028
      },
      instruction:
        'Zet je fiets onder de windturbine waar de 2 banen terug samenkomen.',
      nextSteps:
        "Ben je er klaar voor? Fiets zo'n 8 kilometer verder over dezelfde baan tot je verschillende treinsporen ziet. Let vanaf dat punt op de routewijzer voor de stopplek.",
      type: 'game'
    },
    {
      label: 'Combinant (info + game (china))',
      component: 'Combinant',
      coordinates: {
        lat: 51.37171002,
        lon: 4.288868107
      },
      poiCoordinates: {
        lat: 51.3714823,
        lon: 4.28828875
      },
      instruction: 'Zet je fiets even veilig aan de kant.',
      nextSteps:
        'Volg de Scheldelaan 1 kilometer verder en stop vlak voor je het bordje Noordlandbrug ziet, net voor je de brug oversteekt.',
      type: 'game'
    },
    {
      label: 'Schelde-Rijnkanaal (info)',
      component: 'Rijnkanaal',
      coordinates: {
        lat: 51.36869642,
        lon: 4.297225917
      },
      poiCoordinates: {
        lat: 51.32445346,
        lon: 4.345908631
      },
      instruction:
        "Stop vlak voor het bordje 'Noordlandbrug', net voor je de brug oversteekt en zet je fiets veilig aan de kant.",
      nextSteps:
        'Fiets de Noordlandbrug over en neem een scherpe bocht rechts naar de straat ‘Noordland’. Fiets ten einde tot je terug aan het water – naast de brug – uitkomt. Volg vervolgens het kanaal, tot je bijna niet meer verder kunt en trappen ziet. Daar kom je bij de volgende stopplaats.',
      type: 'info'
    },
    {
      label: 'Uitkijk Opstalvallei',
      component: 'Opstalvallei',
      coordinates: {
        lat: 51.33273941,
        lon: 4.306677751
      },
      poiCoordinates: {
        lat: 51.33288738,
        lon: 4.307807193
      },
      instruction:
        'Nog fit na de tocht die je al afgelegd hebt? Wandel 100 trappen naar boven en geniet van het fantastische zicht vanop dit uitkijkplatform over de Opstalvallei.',
      nextSteps:
        'Fiets een stukje terug en neem het eerste zandweggetje rechts, door het bos, tot je aan de Antwerpsebaan uitkomt. Sla daar rechtsaf, fiets voorbij het bevrijdingsdok tot aan frituur dok 730. Aan de volgende stopplek is het mogelijk even pauze te houden, een drankje te kopen of naar toilet te gaan.',
      type: 'info'
    },
    {
      label: 'Katoen Natie en Tabaknatie',
      component: 'Katoennatie',
      coordinates: {
        lat: 51.32441839,
        lon: 4.34593226
      },
      instruction:
        'We hebben al een heel stuk afgelegd ondertussen. Zin om een voorraadje in te slaan of een frietje te eten? Neem dan hier even pauze! Op het einde van de tocht kan je ook nog pauze houden aan Gaarkeuken 110 in de haven (enkel op weekdagen open), het Pomphuis, Kattendijkdok of aan het Eilandje, waar de fietstocht eindigt.',
      nextSteps:
        'Blijf de Antwerpsebaan volgen en fiets zo’n 20 minuten door tot aan natuurdomein De Kuifeend.',
      type: 'info'
    },
    {
      label: 'De Kuifeend en de Grote Kreek',
      component: 'Kuifeend',
      coordinates: {
        lat: 51.29731251,
        lon: 4.347126975
      },
      poiCoordinates: {
        lat: 51.29760103,
        lon: 4.346927115
      },
      instruction:
        'Zet je fiets even op slot en wandel tot aan het kijkhuis, of wandel het kijkhuisje langs de linkerkant voorbij over het wandelpad, tot je aan het water komt.',
      nextSteps:
        'Van hieruit, De Kuifeend, fietsen we voorbij de voorbij de Grote Kreek verder naar een volgend plekje natuur aan de Put van Ekeren.',
      type: 'info'
    },
    {
      label: 'Put van Ekeren / Recreatiedomein Muisbroek / Bospolder',
      component: 'PutVanEkeren',
      coordinates: {
        lat: 51.28292502,
        lon: 4.390342239
      },
      poiCoordinates: {
        lat: 51.28325049,
        lon: 4.390926961
      },
      instruction:
        'Volg vanaf de parking het bruggetje tot aan de Put van Ekeren en domein Muisbroek, waar je een zicht hebt over het water.',
      nextSteps:
        'Fiets even terug naar de Noorderlaan, fiets verder en neem nadien de Vosseschijnstraat tot aan de volgende stopplek, aan Molenbergnatie.',
      type: 'info'
    },
    {
      label: 'Molenbergnatie (game) + Euroports',
      component: 'Molenbergnatie2',
      coordinates: {
        lat: 51.26085226,
        lon: 4.404406291
      },
      instruction:
        'Zet je fiets even aan de kant van de weg op een veilig plekje.',
      nextSteps:
        'Vervolg de route over de Noorderlaan tot je aan Gaarkeuken 110 aankomt.',
      type: 'game'
    },
    {
      label: 'Gaarkeuken 110 (Pauzeplek)',
      component: 'Gaarkeuken2',
      coordinates: {
        lat: 51.24838627,
        lon: 4.415826506
      },
      instruction:
        'Zet je even op de parking, of ga even binnen in Gaarkeuken 110 voor een drankje of hapje.',
      nextSteps:
        'We fietsen door tot Het Havenhuis. Blijf de weg volgen aan de rechterkant tot je op het kruispunt komt. Steek het kruispunt over richting de brug over het Straatsburgdok. Vanaf daar zie je het Havenhuis al fonkelen. Eens aangekomen aan het Havenhuis, zet je je fiets onder de punt van het Havenhuis, aan de kant van het water.',
      type: 'info'
    },
    {
      label: 'Havenhuis (game)',
      component: 'Havenhuis2',
      coordinates: {
        lat: 51.24096467,
        lon: 4.408251103
      },
      poiCoordinates: {
        lat: 51.24037472,
        lon: 4.407315963
      },
      instruction:
        'Zet je fiets op het Zaha Hadidplein en zet je even op een bankje aan het water.',
      nextSteps:
        'Op naar onze laatste stop! Steek te voet de Mexicobrug over en fiets verder tot aan het MAS. Wil je onderweg nog graag een stop inlassen? Aan je linkerkant passeer je zo dadelijk de Seef brouwerij. Aan de hangars aan de overkant van de straat (kant van het water) kan je ook terecht voor een lekker drankjes en hapjes!',
      type: 'game'
    },
    {
      label: 'MAS Havenpaviljoen (info)',
      component: 'MAS2',
      coordinates: {
        lat: 51.22860066,
        lon: 4.40493073
      },
      type: 'info'
    }
  ],
  geometry: {
    coordinates: [
      [4.39725641, 51.22233405],
      [4.3973637, 51.2227238],
      [4.3946841, 51.2237402],
      [4.397774, 51.2289004],
      [4.3984607, 51.2338449],
      [4.3950274, 51.2372843],
      [4.376488, 51.2394338],
      [4.3610385, 51.2394338],
      [4.3500522, 51.2415832],
      [4.3394092, 51.2463114],
      [4.3225863, 51.2518988],
      [4.31057, 51.2544773],
      [4.3030169, 51.2570557],
      [4.3013003, 51.2607082],
      [4.3085101, 51.2697308],
      [4.3164065, 51.2766039],
      [4.3198398, 51.2826171],
      [4.3188098, 51.286697],
      [4.3119433, 51.2914206],
      [4.3050769, 51.2937823],
      [4.291344, 51.2982905],
      [4.2861941, 51.3025837],
      [4.288352, 51.304057],
      [4.287989, 51.30421],
      [4.287447, 51.304496],
      [4.287363, 51.304547],
      [4.287297, 51.304625],
      [4.287271, 51.304695],
      [4.287282, 51.304792],
      [4.287353, 51.304904],
      [4.287888, 51.305478],
      [4.28811, 51.305733],
      [4.28835, 51.305884],
      [4.288652, 51.30605],
      [4.289135, 51.306265],
      [4.289477, 51.30637],
      [4.290219, 51.306584],
      [4.290354, 51.306625],
      [4.290093, 51.306799],
      [4.289877, 51.307182],
      [4.289679, 51.307568],
      [4.289513, 51.307784],
      [4.289152, 51.308124],
      [4.289092, 51.308234],
      [4.289034, 51.308321],
      [4.288665, 51.308853],
      [4.28848, 51.309209],
      [4.288397, 51.30942],
      [4.288272, 51.309825],
      [4.288243, 51.309935],
      [4.288071, 51.310675],
      [4.288025, 51.310912],
      [4.287357, 51.313964],
      [4.287273, 51.314189],
      [4.286483, 51.318146],
      [4.286098, 51.319948],
      [4.286071, 51.319997],
      [4.286035, 51.32011],
      [4.286013, 51.320156],
      [4.285995, 51.320188],
      [4.285971, 51.32022],
      [4.285937, 51.320271],
      [4.285927, 51.320293],
      [4.285926, 51.320312],
      [4.285927, 51.320331],
      [4.28593, 51.320344],
      [4.285937, 51.320362],
      [4.285948, 51.32038],
      [4.285979, 51.320416],
      [4.286004, 51.320445],
      [4.286011, 51.320459],
      [4.286011, 51.320478],
      [4.285999, 51.320498],
      [4.285981, 51.320514],
      [4.285962, 51.320529],
      [4.28593, 51.32055],
      [4.285915, 51.320565],
      [4.285903, 51.320578],
      [4.285895, 51.320598],
      [4.285889, 51.320616],
      [4.285875, 51.320681],
      [4.285875, 51.320706],
      [4.28589, 51.320827],
      [4.285891, 51.320864],
      [4.285398, 51.322907],
      [4.285416, 51.323065],
      [4.285102, 51.324532],
      [4.285053, 51.32463],
      [4.284997, 51.324709],
      [4.284997, 51.324855],
      [4.285033, 51.324951],
      [4.285145, 51.324965],
      [4.285348, 51.324985],
      [4.285483, 51.324997],
      [4.285316, 51.325788],
      [4.285231, 51.326184],
      [4.284991, 51.327216],
      [4.28468, 51.328649],
      [4.284357, 51.33012],
      [4.284128, 51.331197],
      [4.28396, 51.331941],
      [4.283767, 51.332868],
      [4.283737, 51.333002],
      [4.283689, 51.33321],
      [4.283563, 51.333741],
      [4.283293, 51.335055],
      [4.28324, 51.335332],
      [4.283226, 51.335407],
      [4.283211, 51.336213],
      [4.283347, 51.33689],
      [4.283529, 51.337354],
      [4.283869, 51.338027],
      [4.28434, 51.338633],
      [4.284612, 51.338921],
      [4.284696, 51.339003],
      [4.28476, 51.33906],
      [4.28484, 51.339133],
      [4.28513, 51.339374],
      [4.28532, 51.339518],
      [4.285321, 51.339519],
      [4.28532, 51.339518],
      [4.285231, 51.339565],
      [4.285063, 51.339658],
      [4.284994, 51.339699],
      [4.284966, 51.339723],
      [4.284857, 51.340097],
      [4.28477, 51.34029],
      [4.284642, 51.340515],
      [4.284454, 51.340726],
      [4.284025, 51.34109],
      [4.283625, 51.341311],
      [4.283035, 51.341611],
      [4.282667, 51.341792],
      [4.28223, 51.342036],
      [4.282008, 51.342202],
      [4.281782, 51.342421],
      [4.281671, 51.342588],
      [4.281664, 51.342616],
      [4.28167, 51.342697],
      [4.281673, 51.342738],
      [4.281657, 51.342749],
      [4.281593, 51.342759],
      [4.281552, 51.342772],
      [4.281525, 51.342796],
      [4.281464, 51.342997],
      [4.281443, 51.343116],
      [4.281444, 51.343162],
      [4.281513, 51.343593],
      [4.28151, 51.343705],
      [4.28144, 51.343733],
      [4.281422, 51.343741],
      [4.281459, 51.343985],
      [4.281555, 51.344622],
      [4.281568, 51.34471],
      [4.281596, 51.344726],
      [4.281697, 51.344783],
      [4.281718, 51.344936],
      [4.281764, 51.344984],
      [4.281837, 51.345025],
      [4.281932, 51.345036],
      [4.281944, 51.345105],
      [4.281952, 51.34515],
      [4.281841, 51.345189],
      [4.281764, 51.345248],
      [4.281742, 51.345316],
      [4.281833, 51.345932],
      [4.28179, 51.345959],
      [4.281769, 51.345973],
      [4.28181, 51.346222],
      [4.281892, 51.34676],
      [4.28191, 51.346878],
      [4.281937, 51.346889],
      [4.281987, 51.346909],
      [4.282034, 51.347013],
      [4.282098, 51.347169],
      [4.282247, 51.347534],
      [4.282284, 51.347624],
      [4.282309, 51.34769],
      [4.282314, 51.347706],
      [4.282245, 51.347727],
      [4.282221, 51.347734],
      [4.282171, 51.34775],
      [4.282161, 51.347759],
      [4.28223, 51.348073],
      [4.282249, 51.34812],
      [4.283015, 51.349656],
      [4.283178, 51.34998],
      [4.28327, 51.35018],
      [4.283315, 51.350296],
      [4.28338, 51.350542],
      [4.283407, 51.350842],
      [4.283377, 51.351129],
      [4.283314, 51.351379],
      [4.283218, 51.351614],
      [4.283083, 51.351841],
      [4.282913, 51.35206],
      [4.282658, 51.352323],
      [4.282587, 51.352379],
      [4.282393, 51.352532],
      [4.282083, 51.352732],
      [4.282056, 51.352753],
      [4.282042, 51.352771],
      [4.282026, 51.352793],
      [4.282008, 51.35281],
      [4.281989, 51.352821],
      [4.281959, 51.352829],
      [4.28188, 51.352844],
      [4.281813, 51.352856],
      [4.281783, 51.352869],
      [4.281339, 51.35307],
      [4.281315, 51.353096],
      [4.281316, 51.353126],
      [4.281318, 51.353158],
      [4.281295, 51.353176],
      [4.281124, 51.353203],
      [4.28102, 51.353217],
      [4.280688, 51.353236],
      [4.280669, 51.353252],
      [4.280671, 51.353296],
      [4.280672, 51.353355],
      [4.279948, 51.353398],
      [4.278872, 51.353461],
      [4.276597, 51.353603],
      [4.275474, 51.353672],
      [4.274354, 51.35374],
      [4.272164, 51.353873],
      [4.270989, 51.353942],
      [4.270968, 51.353944],
      [4.270953, 51.353949],
      [4.270937, 51.353955],
      [4.270897, 51.353974],
      [4.27084, 51.354002],
      [4.270815, 51.354007],
      [4.270793, 51.354008],
      [4.270762, 51.354007],
      [4.27062, 51.353975],
      [4.270596, 51.353971],
      [4.270572, 51.353969],
      [4.27054, 51.353969],
      [4.26952, 51.354031],
      [4.26911, 51.354063],
      [4.268733, 51.354105],
      [4.268306, 51.354166],
      [4.268122, 51.354197],
      [4.267955, 51.354229],
      [4.267673, 51.354289],
      [4.267395, 51.354356],
      [4.267035, 51.354463],
      [4.266625, 51.354601],
      [4.266172, 51.354776],
      [4.265794, 51.354943],
      [4.265466, 51.355112],
      [4.264332, 51.355821],
      [4.263333, 51.356459],
      [4.262741, 51.356836],
      [4.262414, 51.357047],
      [4.261576, 51.357587],
      [4.260704, 51.35815],
      [4.259989, 51.358611],
      [4.259389, 51.358995],
      [4.258488, 51.359572],
      [4.258444, 51.359606],
      [4.258368, 51.359717],
      [4.258353, 51.35973],
      [4.258327, 51.35974],
      [4.258304, 51.359744],
      [4.258251, 51.35975],
      [4.258225, 51.359753],
      [4.258209, 51.359757],
      [4.258056, 51.359847],
      [4.257935, 51.359935],
      [4.257419, 51.360264],
      [4.257256, 51.360378],
      [4.257209, 51.360421],
      [4.257163, 51.36045],
      [4.257069, 51.360508],
      [4.256952, 51.360573],
      [4.256486, 51.360856],
      [4.255946, 51.361204],
      [4.255765, 51.361319],
      [4.25554, 51.361477],
      [4.255515, 51.361536],
      [4.255547, 51.361592],
      [4.25556, 51.361653],
      [4.255356, 51.361689],
      [4.255144, 51.361842],
      [4.254744, 51.362181],
      [4.254508, 51.362469],
      [4.254304, 51.362767],
      [4.254048, 51.363255],
      [4.2538, 51.363731],
      [4.25319, 51.36489],
      [4.251134, 51.368769],
      [4.250584, 51.369817],
      [4.250457, 51.370059],
      [4.250156, 51.370628],
      [4.250046, 51.370844],
      [4.249987, 51.370996],
      [4.249947, 51.371123],
      [4.249913, 51.371255],
      [4.249893, 51.371372],
      [4.249887, 51.371487],
      [4.249883, 51.371597],
      [4.249887, 51.3717],
      [4.249896, 51.371843],
      [4.249929, 51.371995],
      [4.24996, 51.372114],
      [4.250008, 51.372252],
      [4.250067, 51.372382],
      [4.250135, 51.37251],
      [4.250198, 51.37263],
      [4.250271, 51.372743],
      [4.250355, 51.372856],
      [4.25046, 51.372983],
      [4.250584, 51.373111],
      [4.2507, 51.373222],
      [4.250802, 51.373316],
      [4.250916, 51.373407],
      [4.251057, 51.373509],
      [4.251205, 51.373607],
      [4.251358, 51.373699],
      [4.251514, 51.373784],
      [4.251667, 51.373863],
      [4.251833, 51.373934],
      [4.252009, 51.374009],
      [4.252188, 51.374077],
      [4.25239, 51.374141],
      [4.252633, 51.374214],
      [4.252843, 51.374264],
      [4.253039, 51.374309],
      [4.253248, 51.374346],
      [4.253445, 51.374373],
      [4.253626, 51.374396],
      [4.253837, 51.374419],
      [4.254017, 51.374433],
      [4.254334, 51.374446],
      [4.254721, 51.374458],
      [4.25737, 51.374556],
      [4.260446, 51.37465],
      [4.261714, 51.374676],
      [4.262639, 51.374676],
      [4.263733, 51.374623],
      [4.264604, 51.374546],
      [4.265475, 51.374452],
      [4.267641, 51.37408],
      [4.271962, 51.373295],
      [4.272919, 51.373147],
      [4.274124, 51.373019],
      [4.276319, 51.372801],
      [4.27969, 51.372487],
      [4.282368, 51.372251],
      [4.283657, 51.372129],
      [4.285148, 51.37199],
      [4.28753, 51.371776],
      [4.287747, 51.371735],
      [4.288391, 51.371676],
      [4.288787, 51.371642],
      [4.288855, 51.371635],
      [4.288787, 51.371676],
      [4.2887, 51.371741],
      [4.288872, 51.371728],
      [4.289041, 51.371715],
      [4.288973, 51.371621],
      [4.289073, 51.37161],
      [4.289225, 51.371593],
      [4.289442, 51.371575],
      [4.290092, 51.371457],
      [4.290739, 51.371304],
      [4.291812, 51.370943],
      [4.29279, 51.370487],
      [4.294135, 51.369678],
      [4.294525, 51.36947],
      [4.29497, 51.369273],
      [4.295226, 51.369173],
      [4.295442, 51.369096],
      [4.295712, 51.369009],
      [4.29595, 51.368942],
      [4.296265, 51.36886],
      [4.296552, 51.368793],
      [4.296856, 51.368735],
      [4.29717, 51.36868],
      [4.297217, 51.368673],
      [4.297678, 51.368604],
      [4.298056, 51.368571],
      [4.29855, 51.36854],
      [4.302373, 51.36838],
      [4.302879, 51.36836],
      [4.304234, 51.368287],
      [4.305753, 51.368198],
      [4.306432, 51.368159],
      [4.307039, 51.368114],
      [4.30831, 51.367996],
      [4.308942, 51.367922],
      [4.309683, 51.36783],
      [4.309885, 51.3678],
      [4.310055, 51.367765],
      [4.310393, 51.367684],
      [4.31056, 51.367632],
      [4.310689, 51.367587],
      [4.310847, 51.367513],
      [4.311053, 51.367397],
      [4.311943, 51.366944],
      [4.312862, 51.366517],
      [4.312873, 51.366464],
      [4.312843, 51.366411],
      [4.312784, 51.366348],
      [4.312403, 51.366471],
      [4.311998, 51.366565],
      [4.311619, 51.366616],
      [4.311, 51.366649],
      [4.306652, 51.366829],
      // Aanpassing
      [4.3065471, 51.3669129],
      [4.303543, 51.3670737],
      [4.3014831, 51.3672344],
      [4.3016547, 51.3603749],
      [4.3019122, 51.3527638],
      [4.3020839, 51.3455268],
      [4.3031138, 51.3413985],
      [4.3038863, 51.3387712],
      // Einde aanpassing
      [4.304148, 51.338787],
      [4.303992, 51.33872],
      [4.30474, 51.337056],
      [4.305497, 51.335366],
      [4.305671, 51.334967],
      [4.30564, 51.334541],
      [4.305671, 51.334335],
      [4.306336, 51.33317],
      [4.306635, 51.332722],
      [4.306682, 51.332731],
      [4.306635, 51.332722],
      [4.306336, 51.33317],
      [4.305671, 51.334335],
      [4.30564, 51.334541],
      [4.305671, 51.334967],
      [4.305497, 51.335366],
      [4.307014, 51.335519],
      [4.307736, 51.335619],
      [4.308144, 51.335761],
      [4.308368, 51.33604],
      [4.308523, 51.336163],
      [4.309244, 51.336203],
      [4.311438, 51.336305],
      [4.311801, 51.3363],
      [4.313043, 51.336534],
      [4.313405, 51.336565],
      [4.313755, 51.336629],
      [4.313921, 51.336524],
      [4.314032, 51.336374],
      [4.314179, 51.336111],
      [4.322762, 51.33677],
      [4.32289, 51.336789],
      [4.323758, 51.335249],
      [4.323949, 51.334865],
      [4.323909, 51.334701],
      [4.323993, 51.334559],
      [4.324108, 51.33444],
      [4.32426, 51.334409],
      [4.325126, 51.33443],
      [4.326826, 51.334553],
      [4.330019, 51.334854],
      [4.331203, 51.33495],
      [4.332036, 51.334988],
      [4.332894, 51.334998],
      [4.333807, 51.334966],
      [4.334536, 51.334939],
      [4.335206, 51.334955],
      [4.336078, 51.335036],
      [4.336758, 51.335112],
      [4.336974, 51.335131],
      [4.337155, 51.335142],
      [4.337377, 51.335151],
      [4.337586, 51.335154],
      [4.337758, 51.335152],
      [4.337933, 51.335146],
      [4.338073, 51.335136],
      [4.338201, 51.335125],
      [4.338314, 51.335113],
      [4.338442, 51.335097],
      [4.338574, 51.335079],
      [4.338705, 51.335058],
      [4.33883, 51.335033],
      [4.33896, 51.335005],
      [4.339107, 51.334972],
      [4.339241, 51.334936],
      [4.339365, 51.3349],
      [4.339504, 51.334858],
      [4.339639, 51.33481],
      [4.339754, 51.334767],
      [4.33986, 51.334723],
      [4.339987, 51.334669],
      [4.340107, 51.334614],
      [4.340203, 51.334564],
      [4.340304, 51.334512],
      [4.340448, 51.334431],
      [4.340617, 51.334332],
      [4.341047, 51.334062],
      [4.341465, 51.333789],
      [4.341607, 51.333697],
      [4.341855, 51.333527],
      [4.342157, 51.333317],
      [4.343271, 51.332547],
      [4.343367, 51.332475],
      [4.343461, 51.332398],
      [4.34356, 51.332309],
      [4.343638, 51.332237],
      [4.343695, 51.332175],
      [4.34376, 51.332102],
      [4.34382, 51.332025],
      [4.34387, 51.331957],
      [4.343918, 51.331885],
      [4.343958, 51.331819],
      [4.343996, 51.33175],
      [4.344033, 51.331671],
      [4.344063, 51.33159],
      [4.344099, 51.331492],
      [4.344115, 51.331449],
      [4.344127, 51.331411],
      [4.344153, 51.331335],
      [4.34416, 51.331312],
      [4.344179, 51.331257],
      [4.344205, 51.331156],
      [4.344217, 51.331112],
      [4.34422, 51.33107],
      [4.344209, 51.331037],
      [4.344196, 51.331009],
      [4.344175, 51.330983],
      [4.344151, 51.330964],
      [4.344109, 51.330939],
      [4.34397, 51.330865],
      [4.343958, 51.330859],
      [4.343874, 51.330819],
      [4.344046, 51.330686],
      [4.344112, 51.330622],
      [4.344191, 51.330544],
      [4.344273, 51.330454],
      [4.34437, 51.33034],
      [4.344461, 51.33013],
      [4.344556, 51.32991],
      [4.344796, 51.32905],
      [4.345257, 51.327496],
      [4.34537, 51.327144],
      [4.345743, 51.326473],
      [4.345954, 51.326109],
      [4.346088, 51.325792],
      [4.346185, 51.325483],
      [4.346251, 51.325403],
      [4.346369, 51.325346],
      [4.346329, 51.325301],
      [4.346265, 51.325228],
      [4.346289, 51.325142],
      [4.346176, 51.325125],
      [4.345956, 51.325103],
      [4.346013, 51.324912],
      [4.345832, 51.324885],
      [4.345598, 51.324857],
      [4.345615, 51.3248],
      [4.345829, 51.324825],
      [4.34594, 51.324419],
      [4.345997, 51.324209],
      [4.345825, 51.324119],
      [4.345832, 51.324097],
      [4.345844, 51.324057],
      [4.346254, 51.324099],
      [4.346286, 51.323994],
      [4.346507, 51.324014],
      [4.346606, 51.324024],
      [4.346673, 51.323793],
      [4.346914, 51.322963],
      [4.347387, 51.321433],
      [4.347621, 51.320575],
      [4.347768, 51.320107],
      [4.347999, 51.319329],
      [4.348019, 51.319249],
      [4.348025, 51.31922],
      [4.348033, 51.319184],
      [4.348039, 51.319154],
      [4.348044, 51.319107],
      [4.348057, 51.318943],
      [4.348056, 51.318887],
      [4.348049, 51.318822],
      [4.348011, 51.318705],
      [4.34793, 51.318481],
      [4.347723, 51.318216],
      [4.347501, 51.318022],
      [4.34719, 51.31785],
      [4.346736, 51.317673],
      [4.345794, 51.317435],
      [4.345423, 51.317295],
      [4.345181, 51.317229],
      [4.344971, 51.317224],
      [4.344168, 51.317023],
      [4.34205, 51.316482],
      [4.341365, 51.316357],
      [4.340892, 51.316308],
      [4.34027, 51.316276],
      [4.33978, 51.316284],
      [4.3395, 51.316298],
      [4.33927, 51.316316],
      [4.339039, 51.316349],
      [4.338557, 51.316423],
      [4.338294, 51.316477],
      [4.337377, 51.316705],
      [4.337022, 51.316623],
      [4.336816, 51.316667],
      [4.336633, 51.31684],
      [4.335697, 51.316963],
      [4.334976, 51.316998],
      [4.334377, 51.316991],
      [4.334309, 51.31699],
      [4.3342, 51.316988],
      [4.333727, 51.316965],
      [4.332841, 51.316871],
      [4.332085, 51.31674],
      [4.331908, 51.316554],
      [4.33168, 51.316498],
      [4.331356, 51.316556],
      [4.330746, 51.316365],
      [4.33028, 51.316189],
      [4.329626, 51.315899],
      [4.329527, 51.315671],
      [4.329364, 51.315594],
      [4.328986, 51.315601],
      [4.328273, 51.315275],
      [4.328183, 51.315063],
      [4.327972, 51.314964],
      [4.327647, 51.314977],
      [4.326912, 51.31465],
      [4.326842, 51.314449],
      [4.326645, 51.314353],
      [4.326333, 51.314384],
      [4.325049, 51.313798],
      [4.324586, 51.313576],
      [4.324306, 51.313408],
      [4.324087, 51.313234],
      [4.323918, 51.313048],
      [4.323838, 51.312896],
      [4.323766, 51.312586],
      [4.323868, 51.312123],
      [4.324468, 51.311439],
      [4.325177, 51.311288],
      [4.325224, 51.311233],
      [4.325571, 51.31083],
      [4.326279, 51.309997],
      [4.326571, 51.309665],
      [4.326643, 51.309587],
      [4.326679, 51.309552],
      [4.326696, 51.309529],
      [4.32669, 51.309519],
      [4.326415, 51.309285],
      [4.326393, 51.309259],
      [4.326371, 51.309219],
      [4.326379, 51.30916],
      [4.326391, 51.309136],
      [4.326398, 51.309105],
      [4.326416, 51.309085],
      [4.326452, 51.309067],
      [4.326494, 51.309016],
      [4.326609, 51.30888],
      [4.326811, 51.308659],
      [4.326861, 51.308606],
      [4.327024, 51.308459],
      [4.327145, 51.308377],
      [4.327284, 51.308291],
      [4.327513, 51.308169],
      [4.327568, 51.308165],
      [4.327704, 51.308096],
      [4.327742, 51.308052],
      [4.327851, 51.307997],
      [4.327913, 51.307965],
      [4.328013, 51.307914],
      [4.328129, 51.307856],
      [4.32821, 51.307816],
      [4.328387, 51.307729],
      [4.328563, 51.307638],
      [4.328829, 51.307501],
      [4.328973, 51.307423],
      [4.329149, 51.307326],
      [4.329315, 51.30721],
      [4.329429, 51.307167],
      [4.329513, 51.307108],
      [4.329626, 51.30701],
      [4.329763, 51.306873],
      [4.329877, 51.30674],
      [4.330068, 51.30652],
      [4.330552, 51.30594],
      [4.330999, 51.305418],
      [4.331431, 51.304922],
      [4.332568, 51.303558],
      [4.334145, 51.301677],
      [4.334482, 51.301327],
      [4.334631, 51.301179],
      [4.334788, 51.301037],
      [4.33488, 51.300958],
      [4.334988, 51.300862],
      [4.335126, 51.300751],
      [4.335361, 51.300547],
      [4.335439, 51.300408],
      [4.33583, 51.300098],
      [4.336696, 51.299368],
      [4.337551, 51.298643],
      [4.337842, 51.298404],
      [4.338802, 51.297598],
      [4.339007, 51.297426],
      [4.339188, 51.297297],
      [4.339452, 51.297128],
      [4.339709, 51.296987],
      [4.339952, 51.296879],
      [4.340216, 51.296778],
      [4.340364, 51.296726],
      [4.340473, 51.296703],
      [4.34058, 51.296698],
      [4.34073, 51.296682],
      [4.341034, 51.296623],
      [4.341371, 51.296568],
      [4.341735, 51.296521],
      [4.341974, 51.296497],
      [4.342415, 51.296461],
      [4.343096, 51.296413],
      [4.343293, 51.296407],
      [4.343534, 51.296402],
      [4.343962, 51.296368],
      [4.344263, 51.296336],
      [4.344518, 51.296303],
      [4.34486, 51.296246],
      [4.345147, 51.296199],
      [4.345448, 51.296133],
      [4.34559, 51.296081],
      [4.345699, 51.296027],
      [4.345804, 51.29598],
      [4.345918, 51.295942],
      [4.346074, 51.295884],
      [4.346196, 51.296032],
      [4.346265, 51.296131],
      [4.346286, 51.296163],
      [4.346306, 51.296194],
      [4.346328, 51.296228],
      [4.346382, 51.296313],
      [4.346419, 51.296364],
      [4.346453, 51.296396],
      [4.346492, 51.296426],
      [4.346521, 51.296445],
      [4.346567, 51.296472],
      [4.346649, 51.29651],
      [4.346707, 51.296534],
      [4.346769, 51.296552],
      [4.346829, 51.296564],
      [4.346931, 51.296578],
      [4.347194, 51.296607],
      [4.347587, 51.296643],
      [4.347665, 51.296651],
      [4.347719, 51.296658],
      [4.347914, 51.296694],
      [4.349101, 51.296916],
      [4.350534, 51.297189],
      [4.350964, 51.297243],
      [4.351702, 51.297302],
      [4.351933, 51.297281],
      [4.352088, 51.297222],
      [4.352217, 51.297152],
      [4.352397, 51.29713],
      [4.352485, 51.297177],
      [4.352586, 51.297272],
      [4.352621, 51.297321],
      [4.352657, 51.297384],
      [4.35268, 51.297422],
      [4.3527, 51.297457],
      [4.352715, 51.297483],
      [4.352738, 51.297523],
      [4.352772, 51.297563],
      [4.352843, 51.29759],
      [4.35272, 51.297651],
      [4.352545, 51.297679],
      [4.352391, 51.297691],
      [4.352105, 51.297695],
      [4.35187, 51.297693],
      [4.351694, 51.297688],
      [4.351564, 51.297675],
      [4.351378, 51.297652],
      [4.350789, 51.297566],
      [4.350203, 51.297481],
      [4.349816, 51.297423],
      [4.349588, 51.297391],
      [4.34939, 51.297368],
      [4.349229, 51.297349],
      [4.34907, 51.297335],
      [4.348822, 51.297316],
      [4.348593, 51.297305],
      [4.348381, 51.297292],
      [4.348122, 51.29728],
      [4.347927, 51.297291],
      [4.347734, 51.297309],
      [4.347522, 51.297337],
      [4.347322, 51.297364],
      [4.347206, 51.297381],
      [4.347322, 51.297364],
      [4.347522, 51.297337],
      [4.347734, 51.297309],
      [4.347927, 51.297291],
      [4.348122, 51.29728],
      [4.348381, 51.297292],
      [4.348593, 51.297305],
      [4.348822, 51.297316],
      [4.34907, 51.297335],
      [4.349229, 51.297349],
      [4.34939, 51.297368],
      [4.349588, 51.297391],
      [4.349816, 51.297423],
      [4.350203, 51.297481],
      [4.350789, 51.297566],
      [4.351378, 51.297652],
      [4.351564, 51.297675],
      [4.351694, 51.297688],
      [4.35187, 51.297693],
      [4.352105, 51.297695],
      [4.352391, 51.297691],
      [4.352545, 51.297679],
      [4.35272, 51.297651],
      [4.352843, 51.29759],
      [4.352925, 51.297623],
      [4.353037, 51.297628],
      [4.353523, 51.297591],
      [4.355464, 51.297414],
      [4.356976, 51.297286],
      [4.357431, 51.297237],
      [4.357802, 51.297191],
      [4.358171, 51.297132],
      [4.358475, 51.297066],
      [4.358877, 51.296976],
      [4.359322, 51.296866],
      [4.359696, 51.296751],
      [4.360024, 51.296643],
      [4.360318, 51.296531],
      [4.360986, 51.296238],
      [4.362026, 51.295783],
      [4.362243, 51.295712],
      [4.362438, 51.295652],
      [4.362613, 51.295611],
      [4.362805, 51.295566],
      [4.362984, 51.295542],
      [4.363181, 51.295524],
      [4.363377, 51.295503],
      [4.363572, 51.295491],
      [4.363815, 51.295485],
      [4.364022, 51.295485],
      [4.364288, 51.295505],
      [4.36454, 51.295537],
      [4.364717, 51.295563],
      [4.364835, 51.295613],
      [4.364925, 51.295695],
      [4.36506, 51.29565],
      [4.365198, 51.295643],
      [4.365313, 51.295653],
      [4.365501, 51.295682],
      [4.365714, 51.295717],
      [4.365867, 51.295741],
      [4.366011, 51.295749],
      [4.366234, 51.295758],
      [4.366498, 51.295756],
      [4.36672, 51.29575],
      [4.366951, 51.295729],
      [4.367163, 51.295704],
      [4.367379, 51.295661],
      [4.371241, 51.294778],
      [4.374828, 51.293956],
      [4.374959, 51.293931],
      [4.375074, 51.293924],
      [4.375172, 51.293923],
      [4.37525, 51.293912],
      [4.375334, 51.293886],
      [4.37538, 51.293854],
      [4.375436, 51.29382],
      [4.375535, 51.293793],
      [4.376125, 51.293656],
      [4.376318, 51.293605],
      [4.376468, 51.293553],
      [4.376661, 51.293482],
      [4.376766, 51.293432],
      [4.376859, 51.293388],
      [4.376952, 51.29334],
      [4.377049, 51.293284],
      [4.377132, 51.293234],
      [4.377208, 51.293181],
      [4.377277, 51.293136],
      [4.377433, 51.293014],
      [4.377546, 51.292914],
      [4.377682, 51.292791],
      [4.37803, 51.292468],
      [4.378142, 51.292367],
      [4.37827, 51.29227],
      [4.378393, 51.292185],
      [4.378576, 51.292077],
      [4.378697, 51.292013],
      [4.378876, 51.291928],
      [4.379022, 51.291861],
      [4.379389, 51.291694],
      [4.379546, 51.291633],
      [4.379472, 51.291553],
      [4.379327, 51.2914],
      [4.37931, 51.291376],
      [4.379287, 51.291333],
      [4.379264, 51.29129],
      [4.379248, 51.291257],
      [4.37921, 51.291135],
      [4.379147, 51.290945],
      [4.379145, 51.290853],
      [4.37917, 51.290767],
      [4.379243, 51.290659],
      [4.379858, 51.290171],
      [4.379731, 51.289917],
      [4.379709, 51.289863],
      [4.379676, 51.289785],
      [4.379655, 51.289733],
      [4.379642, 51.289701],
      [4.379614, 51.289635],
      [4.379529, 51.289433],
      [4.379487, 51.289333],
      [4.379906, 51.289258],
      [4.38051, 51.289124],
      [4.380991, 51.289001],
      [4.381417, 51.288869],
      [4.381758, 51.288749],
      [4.382217, 51.288561],
      [4.382721, 51.288296],
      [4.383252, 51.287974],
      [4.383601, 51.287719],
      [4.383952, 51.287426],
      [4.384209, 51.28729],
      [4.384645, 51.286768],
      [4.385001, 51.286157],
      [4.385199, 51.285715],
      [4.38529, 51.285082],
      [4.385305, 51.28402],
      [4.385296, 51.283007],
      [4.385349, 51.281449],
      [4.385507, 51.28136],
      [4.38555, 51.281342],
      [4.385619, 51.281331],
      [4.385728, 51.281279],
      [4.386225, 51.281398],
      [4.386329, 51.28142],
      [4.386382, 51.281432],
      [4.386472, 51.281451],
      [4.387702, 51.281713],
      [4.390096, 51.282325],
      [4.390172, 51.282344],
      [4.390351, 51.282394],
      [4.39062, 51.282468],
      [4.390669, 51.282581],
      [4.390695, 51.282642],
      [4.390564, 51.282891],
      [4.390412, 51.282975],
      // Start aanpassing
      [4.3901849, 51.2823584],
      [4.385078, 51.2810968],
      [4.3851209, 51.2771775],
      [4.3848205, 51.2753788],
      [4.3844343, 51.2747076],
      [4.3836618, 51.273929],
      [4.3807865, 51.2722644],
      [4.3781257, 51.2706803],
      [4.3768382, 51.2699285],
      [4.3761516, 51.2692036],
      [4.3761087, 51.2685054],
      [4.3764949, 51.2677536],
      [4.3783832, 51.2666527],
      [4.3803573, 51.2659545],
      [4.3828893, 51.2655249],
      [4.3879104, 51.2650147],
      [4.3887687, 51.2648267],
      [4.3886829, 51.2639674],
      [4.3906141, 51.2639674],
      [4.3933606, 51.26386],
      [4.3963218, 51.2635646],
      [4.3973518, 51.2635109],
      [4.3982959, 51.2633498],
      [4.4007421, 51.262195],
      [4.4026304, 51.2614163],
      [4.4033599, 51.2612014],
      // Einde aanpassing
      [4.40398, 51.26108],
      [4.404427, 51.260999],
      [4.40446, 51.260994],
      [4.404681, 51.260961],
      [4.40487, 51.26094],
      [4.405035, 51.260932],
      [4.40518, 51.260929],
      [4.40533, 51.260933],
      [4.405394, 51.260936],
      [4.405487, 51.260941],
      [4.405817, 51.260967],
      [4.406224, 51.260998],
      [4.406878, 51.261042],
      [4.407905, 51.261114],
      [4.408174, 51.261126],
      [4.408422, 51.261134],
      [4.408729, 51.261137],
      [4.412886, 51.261098],
      [4.414491, 51.26108],
      [4.414912, 51.261065],
      [4.415288, 51.260964],
      [4.415494, 51.260915],
      [4.415682, 51.26084],
      [4.415846, 51.260754],
      [4.415978, 51.260651],
      [4.416045, 51.260585],
      [4.41618, 51.260409],
      [4.416218, 51.260319],
      [4.416264, 51.260238],
      [4.416301, 51.260148],
      [4.41632, 51.260094],
      [4.416319, 51.260075],
      [4.416317, 51.260025],
      [4.416315, 51.259986],
      [4.416294, 51.259512],
      [4.416271, 51.25873],
      [4.416256, 51.258204],
      [4.416257, 51.258036],
      [4.416256, 51.258002],
      [4.416243, 51.257342],
      [4.416238, 51.257216],
      [4.416233, 51.257042],
      [4.416233, 51.257029],
      [4.416227, 51.256775],
      [4.416234, 51.256314],
      [4.416229, 51.256078],
      [4.416228, 51.256044],
      [4.416222, 51.255947],
      [4.416213, 51.255689],
      [4.4162, 51.255492],
      [4.416193, 51.255387],
      [4.416183, 51.255164],
      [4.41617, 51.254865],
      [4.416167, 51.254666],
      [4.41616, 51.254127],
      [4.416156, 51.253984],
      [4.416151, 51.253814],
      [4.416152, 51.253763],
      [4.416147, 51.253728],
      [4.416133, 51.253621],
      [4.416115, 51.253545],
      [4.416098, 51.253497],
      [4.416027, 51.253352],
      [4.415957, 51.253235],
      [4.415895, 51.253156],
      [4.415796, 51.253048],
      [4.415614, 51.252875],
      [4.415331, 51.252615],
      [4.415125, 51.252357],
      [4.41498, 51.252231],
      [4.414896, 51.252141],
      [4.414839, 51.252033],
      [4.414794, 51.251929],
      [4.414756, 51.251829],
      [4.414719, 51.251692],
      [4.414705, 51.251604],
      [4.414697, 51.251558],
      [4.414688, 51.251489],
      [4.414684, 51.251438],
      [4.414685, 51.251406],
      [4.414686, 51.251357],
      [4.414689, 51.251279],
      [4.414696, 51.2512],
      [4.414704, 51.251132],
      [4.414721, 51.251044],
      [4.414744, 51.250961],
      [4.414773, 51.250874],
      [4.414841, 51.250717],
      [4.415042, 51.250476],
      [4.415192, 51.250269],
      [4.415261, 51.250179],
      [4.415328, 51.25009],
      [4.41542, 51.249974],
      [4.415661, 51.249687],
      [4.415714, 51.249623],
      [4.415762, 51.249555],
      [4.415815, 51.249469],
      [4.415856, 51.249392],
      [4.415893, 51.249322],
      [4.415941, 51.249218],
      [4.415973, 51.249139],
      [4.416002, 51.249058],
      [4.416025, 51.248952],
      [4.416044, 51.248867],
      [4.416054, 51.248796],
      [4.416056, 51.248741],
      [4.416057, 51.248703],
      [4.416057, 51.248628],
      [4.416055, 51.248564],
      [4.416044, 51.248481],
      [4.41603, 51.248397],
      [4.416024, 51.248369],
      [4.416014, 51.248324],
      [4.415994, 51.248245],
      [4.415972, 51.248175],
      [4.415952, 51.24812],
      [4.415948, 51.248108],
      [4.415913, 51.248025],
      [4.415869, 51.247942],
      [4.415836, 51.247883],
      [4.415799, 51.247824],
      [4.415743, 51.247747],
      [4.415696, 51.24769],
      [4.415623, 51.2476],
      [4.415561, 51.247539],
      [4.415502, 51.247478],
      [4.415417, 51.247399],
      [4.415343, 51.247334],
      [4.415281, 51.247282],
      [4.415197, 51.247219],
      [4.415098, 51.24715],
      [4.415014, 51.24709],
      [4.414707, 51.24687],
      [4.414447, 51.246656],
      [4.414263, 51.246477],
      [4.41412, 51.246288],
      [4.413793, 51.245805],
      [4.413752, 51.245713],
      [4.41374, 51.245569],
      [4.413741, 51.245518],
      [4.413744, 51.245484],
      [4.413758, 51.245436],
      [4.413748, 51.245288],
      [4.413729, 51.245129],
      [4.413691, 51.245039],
      [4.413611, 51.245053],
      [4.413573, 51.245047],
      [4.413462, 51.245011],
      [4.413383, 51.244974],
      [4.41332, 51.244965],
      [4.413234, 51.244907],
      [4.413235, 51.244864],
      [4.413226, 51.24478],
      [4.413219, 51.244715],
      [4.413177, 51.244684],
      [4.413241, 51.244656],
      [4.413088, 51.244493],
      [4.412972, 51.244309],
      [4.412943, 51.24421],
      [4.412678, 51.242842],
      [4.412639, 51.242711],
      [4.412539, 51.242487],
      [4.412398, 51.242214],
      [4.411903, 51.241276],
      [4.411671, 51.240853],
      [4.411599, 51.240746],
      [4.411497, 51.240648],
      [4.411391, 51.240565],
      [4.411277, 51.240499],
      [4.411063, 51.240388],
      [4.410793, 51.240306],
      [4.41048, 51.240259],
      [4.41029, 51.240249],
      [4.410038, 51.240257],
      [4.409809, 51.240288],
      [4.409544, 51.240364],
      [4.409407, 51.240424],
      [4.40918, 51.240559],
      [4.409099, 51.240607],
      [4.408932, 51.240773],
      [4.408797, 51.240904],
      [4.408676, 51.241024],
      [4.408555, 51.240978],
      [4.40831, 51.240883],
      [4.408199, 51.240845],
      [4.408255, 51.240912],
      [4.408281, 51.240959],
      [4.408255, 51.240912],
      [4.408199, 51.240845],
      [4.408153, 51.240823],
      [4.408122, 51.240796],
      [4.408086, 51.240745],
      [4.408056, 51.240662],
      [4.408088, 51.24056],
      [4.408169, 51.240479],
      [4.408335, 51.240395],
      [4.408545, 51.240278],
      [4.408716, 51.240143],
      [4.408806, 51.240047],
      [4.408842, 51.239997],
      [4.40891, 51.239842],
      [4.408931, 51.239744],
      [4.408943, 51.238958],
      [4.408935, 51.238312],
      [4.408948, 51.238048],
      [4.408951, 51.237994],
      [4.408964, 51.237915],
      [4.408995, 51.237665],
      [4.409042, 51.237402],
      [4.409064, 51.236985],
      [4.409062, 51.236644],
      [4.409052, 51.236261],
      [4.409055, 51.236101],
      [4.409062, 51.235941],
      [4.409129, 51.23563],
      [4.409129, 51.235536],
      [4.40913, 51.235393],
      [4.40912, 51.235005],
      [4.409127, 51.234456],
      [4.409142, 51.233387],
      [4.409154, 51.232894],
      [4.409154, 51.23278],
      [4.409154, 51.232722],
      [4.409155, 51.232294],
      [4.409155, 51.231641],
      [4.409155, 51.231435],
      [4.409163, 51.231123],
      [4.409163, 51.231039],
      [4.409163, 51.23098],
      [4.409163, 51.230969],
      [4.409163, 51.230956],
      [4.409163, 51.230898],
      [4.409164, 51.230849],
      [4.408952, 51.230848],
      [4.408693, 51.230848],
      [4.408552, 51.230857],
      [4.408422, 51.230879],
      [4.40788, 51.231024],
      [4.407704, 51.231072],
      [4.407612, 51.231096],
      [4.407521, 51.23111],
      [4.407431, 51.231114],
      [4.407305, 51.231115],
      [4.407024, 51.231115],
      [4.406647, 51.231112],
      [4.406472, 51.2311],
      [4.40549, 51.231099],
      [4.405363, 51.231099],
      [4.405452, 51.22981],
      [4.405461, 51.229679],
      [4.40547, 51.229544],
      [4.40549, 51.229201],
      [4.4055, 51.229082],
      [4.405511, 51.228942],
      [4.40553, 51.228705],
      [4.405538, 51.228601]
    ],
    type: 'LineString'
  }
}
